// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2n3gc","header":"ReportDetails_header__2qlEV","title":"ReportDetails_title__2WJ4H","left":"ReportDetails_left__1zWEf"};